import React, { useContext, useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '..';
import { icons } from './icons';
import { BasicIconProps } from './types';
import { SvgContainer } from './styles';

const BasicIcon = ({
  id,
  name,
  size = 'medium',
  color = '#4d4d4d',
  onClick,
  disabled,
  clickable,
}: BasicIconProps) => {
  const { actualTheme } = useContext(ThemeContext);
  const Icon = icons[name] || icons.home;
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (onClick && !disabled) {
        e.stopPropagation();
        onClick();
      }
    },
    [onClick, disabled],
  );

  return (
    <ThemeProvider theme={actualTheme}>
      <SvgContainer
        id={id}
        color={color}
        size={size}
        data-testid={id || 'icon-test-id'}
        onClick={handleClick}
        clickable={(typeof clickable === 'undefined' ? !!onClick : clickable) && !disabled}
        disabled={disabled}
      >
        <Icon
          height={actualTheme.basicIcon[size].size}
          width={actualTheme.basicIcon[size].size}
          viewBox="0 0 24 24"
        />
      </SvgContainer>
    </ThemeProvider>
  );
};

export default BasicIcon;
